<template>
  <div class="modal-btn-group">
    <Button class="cancle" @click="$emit('cancel')">{{ cancelText }}</Button>
    <Button class="sure" type="primary" :loading="loading" @click="$emit('confirm')">{{ confirmText }}</Button>
  </div>
</template>

<script>
// 通用弹窗底部按钮组(收敛各 Modal 重复的 取消/确定 + .modal-btn-group 样式)
// 用法: <dialog-footer @cancel="show=false" @confirm="submit" /> 放进 Modal 的 #footer slot
export default {
  name: 'DialogFooter',
  props: {
    cancelText: { type: String, default: '取消' },
    confirmText: { type: String, default: '确定' },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style lang="less" scoped>
.modal-btn-group { text-align: right; }
.modal-btn-group .cancle { margin-right: 8px; }
</style>
